export default __webpack_public_path__ + "static/media/aiyu.338a08f3.jpg";